import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71d0dea9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "related-service-card" }
const _hoisted_2 = { class: "related-service-card__category-tag" }
const _hoisted_3 = { class: "related-service-card__body" }
const _hoisted_4 = { class: "related-service-card__content" }
const _hoisted_5 = { class: "related-service-card__category" }
const _hoisted_6 = { class: "label-small related-service-card__address" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "related-service-card__price-row" }
const _hoisted_9 = {
  key: 0,
  class: "body-2-semi related-service-card__prices-wrapper"
}
const _hoisted_10 = {
  key: 0,
  class: "related-service-card__price--discounted"
}
const _hoisted_11 = {
  key: 1,
  class: "related-service-card__max-guests"
}
const _hoisted_12 = { class: "related-service-card__footer" }

import { PropType, computed, ref, reactive } from 'vue'
import BaseIcon from '../BaseIcon.vue'
import PhotoGallery from '@/components/public/PhotoGallery.vue'
import { FORMATS, SIZES } from '@/enums/components'
import BaseButton from '../BaseButton.vue'
import { RelatedService } from '@/models/public/service.model'
import { getValidationErrorData } from '@/utils/errors'
import {
  useCreateOrderMutation,
  createHousingServiceOrderItem,
} from '@/queries/cart'
import {
  AvailabilityPayload,
  CreateHousingServiceOrderItem,
  OrderItemReferral,
} from '@/models/public/order.model'
import { useOrderStore } from '@/store/order'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import { formatCurrency } from '@/utils/formatters'
import { TRANSLATION_TYPE } from '@/enums/public'
import { goToServicePublicDetails } from '@/utils/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedServiceResultCard',
  props: {
  isPreview: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  relatedService: {
    type: Object as PropType<RelatedService>,
    required: true,
  },
  availabilityRequest: {
    type: Object as PropType<AvailabilityPayload>,
    default: () => ({}),
  },
  referral: {
    type: Object as PropType<OrderItemReferral | undefined>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

const orderStore = useOrderStore()
const i18n = useI18n()
const toast = useToast()



const mapsUrl = computed(() => {
  return (
    'https://maps.google.com/?q=' +
    props.relatedService.location?.latitude_decimal_degree +
    ',' +
    props.relatedService.location?.longitude_decimal_degree
  )
})

const getType = (key: string) => {
  return {
    EVENT: i18n.t('serviceType.eventLabel'),
    EXPERIENCE: i18n.t('serviceType.experienceLabel'),
    HOUSING: i18n.t('serviceType.housingLabel'),
    MONEYJAR: i18n.t('serviceType.salesItemLabel'),
  }[key]
}

const additionalServiceQuantities = reactive<Record<string, number>>({})

const isAddToCartLoading = ref<boolean>(false)
const errors = ref<Record<string, unknown> | undefined>(undefined)

const isAvailable = computed(() => {
  return (
    !props.disabled &&
    props.availabilityRequest.check_in &&
    props.availabilityRequest.check_out &&
    props.availabilityRequest.adults > 0 &&
    props.relatedService.max_guests >=
      props.availabilityRequest.adults + props.availabilityRequest.children
  )
})

const { mutateAsync: createOrder } = useCreateOrderMutation()

const addHousingServiceItemToCart = async () => {
  isAddToCartLoading.value = true
  errors.value = undefined
  if (!orderStore.orderUuid) {
    try {
      const data = await createOrder()
      orderStore.updateOrder(data)
    } catch (error: unknown) {
      errors.value = getValidationErrorData(error)
      isAddToCartLoading.value = false
      return
    }
  }
  const payload: CreateHousingServiceOrderItem = {
    service: props.relatedService.id,
    adults: props.availabilityRequest.adults,
    children: props.availabilityRequest.children,
    check_in: props.availabilityRequest.check_in,
    check_out: props.availabilityRequest.check_out,
    quantity: 1,
    additional_services: additionalServiceQuantities,
  }
  //TODO: update if in cart
  createHousingServiceOrderItem(orderStore.orderUuid, payload)
    .then((response) => {
      orderStore.updateOrder(response.data)
      toast.success(i18n.t('addToCartSuccess'))
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
    .finally(() => {
      isAddToCartLoading.value = false
    })
}

const isDiscounted = computed<boolean>(() => {
  return (
    props.relatedService.base_total !== props.relatedService.discounted_total
  )
})

const openServiceDetails = () => {
  goToServicePublicDetails(
    props.relatedService.hash_id,
    props.relatedService.name.content,
    props.referral?.referral_type,
    props.referral?.referral_code,
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.relatedService.gallery)
      ? (_openBlock(), _createBlock(PhotoGallery, {
          key: 0,
          photos: __props.relatedService.gallery,
          "show-header-only": true,
          "is-show-photo-gallery": false,
          class: "related-service-card__gallery",
          onNavigateToService: openServiceDetails
        }, null, 8, ["photos"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(getType(__props.relatedService.type)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "headline-4 related-service-card__heading",
          onClick: openServiceDetails
        }, [
          _createTextVNode(_toDisplayString(__props.relatedService.name?.content) + " ", 1),
          (__props.relatedService?.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
            ? (_openBlock(), _createBlock(BaseIcon, {
                key: 0,
                icon: "google-translate",
                style: {"height":"16px","width":"revert"}
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.relatedService.service_category), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseIcon, {
            icon: "map-pin",
            size: 14,
            class: "related-service-card__address-icon"
          }),
          _createElementVNode("a", {
            href: _unref(mapsUrl),
            target: "_blank",
            class: "related-service-card__address-text"
          }, _toDisplayString(__props.relatedService.location?.full_address), 9, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (__props.relatedService.base_price)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass(["related-service-card__price", {
                'related-service-card__price--base related-service-card__price--discounted':
                  _unref(isDiscounted),
              }])
                }, _toDisplayString(_unref(formatCurrency)(__props.relatedService.base_price)), 3),
                (_unref(isDiscounted))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(formatCurrency)(__props.relatedService.discounted_total)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.relatedService.max_guests)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(BaseIcon, {
                  icon: "user",
                  size: 20
                }),
                _createElementVNode("span", null, "x " + _toDisplayString(__props.relatedService.max_guests), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseButton, {
          format: _unref(FORMATS).SECONDARY,
          size: _unref(SIZES).SMALL,
          label: _ctx.$t('relatedService.seeMore'),
          class: "related-service-card__button",
          "icon-right": "",
          onClick: _withModifiers(openServiceDetails, ["prevent"])
        }, null, 8, ["format", "size", "label", "onClick"]),
        (__props.relatedService.base_price)
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              format: _unref(FORMATS).PRIMARY,
              size: _unref(SIZES).SMALL,
              label: _ctx.$t('add'),
              loading: isAddToCartLoading.value,
              class: "related-service-card__button related-service-card__button--add",
              icon: "suit-case",
              disabled: __props.isPreview || !_unref(isAvailable),
              "icon-right": "",
              onClick: _withModifiers(addHousingServiceItemToCart, ["prevent"])
            }, null, 8, ["format", "size", "label", "loading", "disabled", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})